/**
 * If mobile it opens the navigation as sidebar, when clicking somewhere else
 * when the sidebar is open it hides automatically.
 */

const navbarInit = () => {
  const header: Element = document.querySelector('.header');
  const headerMenu: Element = header.querySelector('.header__menu');
  const toggler: Element = header.querySelector('.header__toggler');
  const headerActive: string = 'header--active';
  const togglerActive: string = 'toggler--active';

  // Add active class to current click
  // and stop propagation
  toggler.addEventListener('click', (e: Event) => {
    e.stopPropagation();
    header.classList.toggle(headerActive);
    toggler.classList.toggle(togglerActive);
  });

  // Stop propagation when clicking on
  // element with .header__menu class
  headerMenu.addEventListener('click', (e: Event) => {
    e.stopPropagation();
  });

  // Remove active class when clicked somewhere else
  document.addEventListener('click', () => {
    header.classList.remove(headerActive);
    toggler.classList.remove(togglerActive);
  });
};

export default navbarInit;
